import React, {
    useEffect,
    useState
} from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from "../custom-hooks/index";
import { useDispatch } from "react-redux";
import { inputHelper } from "../utils/index";
import { routeConstants } from '../constants';

const Form = ({
    children,
    redirectTo
}) => {
    const history = useHistory();
    const [reactChildren, setReactChildren] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        clearReactChildren();
        recursiveMap(children, (child) => { 
            setReactChildren(reactChildren  => [...reactChildren , child])
        })
    },[children])

    const clearReactChildren = () => {
        setReactChildren([...[]])
    }

    const recursiveMap = (children, callback) => {
        return React.Children.map(children, child => {
            if (!React.isValidElement(child)) {
                return child;
            }

            if (child.props.children) {
                child = React.cloneElement(child, {
                    children: recursiveMap(child.props.children, callback)
                });
            }

            return callback(child);
        })
    }

    const {
        handleSubmit,
        handleChange,
        errors,
        values,
        register
    } = useForm(nextPage, inputHelper.validate)

    function nextPage() {
        console.log('next page');
        history.push({
            pathname: redirectTo,
            state: { 
                background: {
                    pathname: "/",
                    search: routeConstants.queryString
                }
            }
          });
    }

    const resetRegister = () => {
        register(null, null)
    }

    return (
        <form noValidate onSubmit={handleSubmit}>
            {resetRegister()}
            {React.Children.map(reactChildren, (child, i) => {
                return child.props.name
                    ? React.createElement(child.type, {
                        ...{
                            ...child.props,
                            onChange: handleChange,
                            errors: errors,
                            values: values,
                            register: register(child.props.name, child.props.registerRules),
                            key: child.props.name
                        }
                    })
                    : child;
            })}
        </form>
    )
}

export default Form;
